import { fplIcon } from './fplIcon';
import { FolderEmptyIconLocal } from './FolderEmptyIcon';
import type { SvgComponent } from '@/types/SvgComponent';

/**
 * `icon.24.folder.large` artwork at 36x36 — the FPL variant intended for larger renders
 * (`data-fpl-icon-size="24L"`), which fills more of the 24 viewBox than plain `icon.24.folder`.
 *
 * FPL ships it at 24 only, and `fplIcon` drops caller `width`/`height`, so `FolderEmptyIcon` cannot
 * hold the larger sizes the dashboard folder thumbnails and cards used. The 24 viewBox is kept so
 * the artwork scales rather than being cropped.
 */
const FolderLargeEmptyIconFpl: SvgComponent = (props) => {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="var(--fpl-icon-color, var(--color-icon))"
        d="M9.879 4a2 2 0 0 1 1.414.586L13.707 7H19a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM5 5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.707l-2.707-2.707A1 1 0 0 0 9.879 5zm12.5 10a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z"
      />
    </svg>
  );
};

/**
 * Flag off renders the legacy `FolderEmptyIcon` artwork, so callers must keep passing the size they
 * used before (40/42 depending on the surface). Flag on ignores those props and renders the FPL
 * glyph at a normalised 36.
 */
export const FolderLargeEmptyIcon = fplIcon(FolderEmptyIconLocal, FolderLargeEmptyIconFpl);
